import Grid from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React, { Dispatch, FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Action } from 'redux';
import { ItineraryStatus } from '../../models/itinerary';
import { AppState } from '../../store/model';
import { combinationInit } from '../../store/reducers/itinerary/actions';
import { getStatus } from '../../store/reducers/itinerary/selectors';

interface OwnProps {
  isSelected?: boolean;
  isRecommended?: boolean;
  isFirstAirTitle?: boolean;
}

interface StateProps {
  status?: ItineraryStatus;
}

interface DispatchProps {
  runInit: void;
}

interface TableAirTitleProps
  extends OwnProps,
    StateProps,
    DispatchProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

const _TableAirTitleBase: FunctionComponent<TableAirTitleProps> = ({
  isSelected,
  classes,
  isRecommended,
  isFirstAirTitle,
}) => {
  const titleText = isRecommended ? 'Recommended' : 'Alternative';
  return (
    <Grid
      className={classNames(classes.warpContainer, {
        [classes.selectedBackground]: isSelected,
        [classes.borderLeft]: !isFirstAirTitle,
      })}
    >
      <Typography className={classes.titleText}>{titleText}</Typography>
    </Grid>
  );
};

const styles = (theme: Theme) => {
  const { zeno: { shortlist } } = theme;
  return createStyles({
    mainWarp: {},
    titleText: {
      textAlign: 'center',
      color: 'white',
      fontSize: 14,
      fontFamily: 'Roboto',
      fontWeight: 400,
      lineHeight: 20,
      letterSpacing: 0.15,
      wordWrap: 'break-word',
    },
    warpContainer: {
      width: '233px',
      height: '35px',
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingLeft: 67,
      paddingRight: 67,
      background: shortlist && shortlist.air.shortlisted.main,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'inline-flex',
      boxSizing: 'border-box',
    },
    selectedBackground: {
      background: theme.zeno.travelModes.air.main,
    },
    borderLeft: { borderLeft: '1px solid #E0E0E0' },
  });
};

const mapStateToProps = (state: AppState): StateProps => {
  return {
    status: getStatus(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  runInit: () => {
    dispatch(combinationInit());
  },
});

const enhance = compose<TableAirTitleProps, OwnProps>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  injectIntl,
);

export const TableAirTitle = enhance(_TableAirTitleBase);

TableAirTitle.displayName = 'TableAirTitleBase';
